export default __webpack_public_path__ + "static/media/gastronomicos.b95a1646.jpg";